export interface IBank {
  code: string;
  description: string;
}

export const Banks: IBank[] = [
  {
    code: '1',
    description: 'DBS/POSB'
  },
  {
    code: '12',
    description: 'ANZ'
  },
  {
    code: '8',
    description: 'Bank of China'
  },
  {
    code: '9',
    description: 'Bank of Singapore'
  },
  {
    code: '10',
    description: 'CIMB'
  },
  {
    code: '4',
    description: 'Citibank'
  },
  {
    code: '7',
    description: 'HSBC'
  },  
  {
    code: '6',
    description: 'Maybank'
  },  
  {
    code: '2',
    description: 'OCBC'
  },
  {
    code: '5',
    description: 'Standard Chartered'
  },
  {
    code: '3',
    description: 'UOB'
  },
  {
    code: '11',
    description: 'Others'
  },
]